import s from './Loader.module.scss';

const Loader = () => {
  return <div className={s.loader}></div>;
};

export default Loader;
